module.exports = {
    language: {
        name: 'English',
        code: 'en'
    },
    menu: {
        title: 'CAA审稿系统'
    },
    login: {
        user: {
            blur: '使用用户身份登录',
            title: '用户'
        },
        chair: {
            blur: '使用会议主席身份登录',
            title: '主席'
        },
        title: '登录',
        dashboard: '首页',
        message: '您还未登录，请选择登录身份',
        email: '邮箱或者登录名',
        password: '登录密码',
        rule: {
            userEmail: '请输入邮箱地址',
            password: '请输入密码'
        },
        jumpNow:'立即跳转',
        jumpCancel: '取消跳转',
        loginMsg1:'您正在访问 {year}年中国自动化大会投稿系统。',
        loginMsg2:'是否跳转至 2025年中国自动化大会投稿系统？'
    },
    header: {
        profile: '属性',
        rePwd: '重置密码',
        switchRole: '切换角色',
        logout: '注销',
        userName: '用户名',
        email: '邮箱',
        password: '密码',
        passwordConfirm: '确认密码',
        rule: {
            adminName: '请输入用户名',
            password: '请输入密码',
            passwordConfirm: '请输入确认密码',
            passwordNotEqual: '两次密码输入不一致',
            email: '请输入邮箱'
        }
    },
    button: {
        posterType: '展示形式',
        ResetPoster: '重置海报',
        posterArrange: '海报安排', //Poster arrangement
        poster: 'Poster',
        oral: 'Oral',
        online: '线上',
        offline: '线下',
        close: '关闭审稿',
        closeDlg: '关闭',
        unwind: '重新签署',
        GoSigning: '去签署',
        copyrightSubmission: 'Copyright Submission',
        importMessage: '请上传评审员导入模板',
        inviteMessage: '请上传评审员邀请模板',
        reviewerImportTemplate: '评审员导入模板',
        reviewerImport: '导入评审',
        reviewerInviteTemplate: '评审员邀请模板',
        reviewerInvite: '邀请评审员',
        print: '打印',
        back: '返回',
        query: '查询',
        create: '创建',
        download: '下载',
        downloadTemplate: '下载专属模板',
        downloadCertificate: '下载证书',
        submit: '确定',
        reset: '重置',
        cancel: '取消',
        cochair: '副主席',
        reviewer: '评论员',
        batchReviewer: '批量评论员',
        review: '评论',
        register: '参会注册',
        finalConfirm: '终稿上传',
        copyright: '版权',
        chooseSession: '选择议题',
        detail: '查看',
        detailBack: '驳回',
        judge: '评判',
        delete: '删除',
        edit: '编辑',
        paperSet: '集合',
        finalSubmit: '终稿上传',
        template: '模板',
        import: '导入',
        revoke: '撤销',
        insert: '创建',
        upload: {
            text: '将文件拖到此处，或点击上传',
            tip: '只能上传pdf文件，且不超过200MB(若无更新，可不重新上传)',
            tipDoc: '只能上传pdf、doc、docx文件，且不超过200MB(若无更新，可不重新上传)',
            tipZip: '只能上传pdf、rar、zip文件，且不超过200MB(若无更新，可不重新上传)',
        },
        rechecking:{
            send:'发送提醒',
            downloadTemplate:'下载模版',
            upTemplate:'导入查重结果',
            upTemplate2:'导入查重报告',
            checkingResult:'查重结果',
            download:'下载论文',
            viewRepord:'查看报告',
        }
    },
    rechecking:{
        duplicateRate:'查重率',
        duplicateFile:'报告',
        duplicateTag:'查重结果',
        submitUserName:'作者',
        submitUserPhone:'手机号',
        submitUserEmail:'邮箱',
        paperStatus:'论文状态',
        pass:'通过',
        noPass:'未通过',
        awaitDuplicate:'待查重',
    },
    message: {
        poster: '报告形式确定后不可更改，请谨慎选择。',
        isCac: '请上传您的论文壁报',
        posterMes: '请上传海报！',
        postermessage: '烦请您准备口头报告PPT内容，具体会议时间另行通知。',
        poster949message: '本届会议口头报告（Oral）集中于11月1日进行，每篇论文预计10分钟时间，如您选择此形式，请确认时间是否允许，具体时间安排后续会有专人与您对接。',
        picSize:'建议上传图片尺寸：1900px*2700px，图片大小不超过10MB。',
        picSize2:'建议上传图片尺寸：{size}，图片大小不超过10MB。',
        certificatePro: '您暂无证书可查看',
        closeMessage: '关闭审稿？',
        detailBackTip: '确定要驳回评审意见吗',
        prompt: '提示',
        finalConfirm: '版权协议签署是英文论文最终收录的必要条件，在您上传终稿之前，请按照系统提示完成版权协议提交，点击"去签署"开始版权协议签署',
        finalConfirm2: '请先完成版权协议签署再进行终稿提交操作，点击"去签署"开始版权协议签署',
        chooseReviewer1: '审稿人与作者可能为同一单位，是否仍然分配？',
        chooseReviewer2: '该数据已被选择',
        ecopyrightTip: '签署完成后，请务必在最后一步点击“Done”按钮返回投稿系统。 <br> 点击“确定”跳转到IEEE版权签署页面。',
        EcopyrightNo: 'Ecopyright签署暂未开通，请稍后再试，或关注官网最新通知。',
        IsChinesePdf:'检测到pdf内容为 ',
        IsChinesePdf1:'检测到pdf可能为 ',
        IsChinesePdf2:' ，请确认后提交！',
        finalUploadCheck:"请先注册缴费，再上传终稿。",
        statusAndId: "请选择论文状态或论文ID"

    },
    summary: {
        day: '天',
        status: {
            text: '论文状态',
            subtext: '每个状态的论文',
            series: '访问来源'
        },
        trend: '论文走势',
        trend2: '审稿人数量变化统计',
        cochair: {
            text: '副主席',
            subtext: '副主席在所有用户中的占比',
            other: '其他数量',
            series: '访问来源'
        },
        reviewer: {
            text: '评论员',
            subtext: '评论员在所有用户中的占比',
            other: '其他数量',
            series: '访问来源'
        },
         // copyright提交统计
        reviewer2: {
            text: 'Copyright',
            subtext: 'copyright提交统计',
            series: '提交数量'
        },
        reviewer3: {
            text: '终稿',
            subtext: '终稿提交统计',
            series: '提交数量'
        },
        tableData: {
            text: '投稿量统计',
            subtext: '各topic投稿量统计',
            name: '主题',
            count: '统计',
            total: '合计'
        },
        tableData1: {
            text: '论文数量统计',
            subtext: '各机构分组论文数量统计',
            name: '机构',
            count: '统计',
            total: '合计'
        },
        // 投稿地域统计
        tableData2: {
            text: '投稿地域统计',
            subtext: '各地域分组论文数量统计',
            name: '地域',
            count: '统计',
            total: '合计'
        },
        //日志
        OperateLog: {
            id: 'ID',
            paperId: 'ID',
            operDesc: '描述',
            operTime: '时间'
        }
    },
    copyrightSubmission: {
        title: '版权提交',
        PubTitle: '会议全称',
        ArtTitle: '文章标题',
        AuthName: '所有作者',
        ArtId: 'paper ID',
        ArtSource: '会议CODE',
        ArtEmail: '所有作者Email',
        rtrnurl: '回调URL'
    },
    paper: {
        address: '地点',
        showTime: '时间',
        boardCode: '展板编号',
        printSize: '海报打印标准尺寸',
        Nopayment: '未缴费',
        Underreview: '待审核',
        Paymentsuccess: '已缴费',
        successornot: '已缴费未完成',
        Applyrefund: '申请退款',
        Fefunded: '已退款',
        NoRegister: '未注册',
        registerStatus: '注册状态',
        yes: '是',
        no: '否',
        copyrightSubmission: '版权提交',
        paperCount: '论文数量',
        whiteTitle: '您好，投稿已截止。',
        titles: '论文ID、标题、作者、邮箱、机构',
        id: '论文ID',
        title: '论文标题',
        student: '是否学生',
        language: '论文语言',
        topic: '领域',
        session: '议题(选填)',
        invitationCode: '邀请码',
        presentationType: '出席类型',
        // OnlinePresentation: '线上演讲（仅适用于特殊情况）',
        OnlinePresentation: 'Online presentation (reserved for exceptional circumstances only)',
        onlineTag: '线上线下',
        presentationTypeNode: '此处请选择意向的论文展示方式，会务组将参考论文意向结合日程安排安排论文展示，最终以大会官网公示为准。',
        // presentationTypeNode: 'Please select your intended way of paper presentation. The CAC affairs team will refer to the paper intention and schedule to arrange the paper presentation, and finally the official website of the CAC shall prevail.',
        status: '状态',
        reviewerd: '已评论数>=',
        ifIntoSet: '是否在集合中',
        operation: '操作',
        cochair: '副主席',
        cochairId: '副主席ID',
        reviewerId: '评论员ID',
        review: '评论',
        paperOperate: '操作',
        paperOperateTitle: '您需要操作的论文',
        paperJudge: '评判',
        paperJudgeTitle: '您需要评判的论文',
        paperSession: '议题',
        paperSessionTitle: '尚未选择议题的论文',
        paperCochair: '副主席操作',
        paperCochairTitle: '副主席操作视角',
        paperAllTitle: '所有论文',
        submitUser: '提交人',
        submitUserEmail: '提交人邮箱',
        submitUserPhone: '提交人电话',
        keywords: '关键字',
        abstract: '论文摘要',
        file: '论文文件',
        comment: '备注',
        author: '作者',
        reader: '审稿人',
        number: '序号',
        authorId: '作者ID',
        authorSalutation: '称谓',
        authorName: '姓名',
        authorOrganization: '机构',
        authorCountry: '国家',
        authorEmail: '邮件',
        authorEmailMessage: '请输入有效的邮箱地址',
        authorEmailSpaceMessage: '邮箱地址不能包含空格',
        evaluateType: '评估类型',
        recommendType: '建议类型',
        ifBest: '是否推选为最佳论文',
        bestReason: '推荐理由',
        reviewComment: '评论',
        organizationRate: '组织(糟糕-->优异)',
        organizationRateArr: ['糟糕', '差', '中等', '良好', '优异'],
        clarityRate: '清晰度(低-->高)',
        clarityRateArr: ['低', '较低', '中等', '较高', '高'],
        lengthRate: '长度(长-->短)',
        lengthRateArr: ['长', '较长', '中等', '较短', '短'],
        referencesRate: '参考(不完全--> 足够)',
        referencesRateArr: ['不完全', '较不完全', '中等', '较多', '足够'],
        correctnessRate: '正确性(错误-->正确)',
        correctnessRateArr: ['错误', '较错', '中等', '较正确', '正确'],
        significanceRate: '重要性(低-->高)',
        significanceRateArr: ['低', '较低', '中等', '较高', '高'],
        originalityRate: '独创性低(-->高)',
        originalityRateArr: ['低', '较低', '中等', '较高', '高'],
        surveyCoverageRate: '调查范围(窄-->宽)',
        surveyCoverageRateArr: ['窄', '较窄', '中等', '较宽', '宽'],
        contributionRate: '贡献(没有新成果-->有重大意义)',
        contributionRateArr: ['没有新成果', '较少成果', '中等', '比较有意义', '有重大意义'],
        contributionDetail: '贡献内容',
        improveMethods: '改进方法',
        reviewerNums: '评论数',
        totalReviewerNums: '总评论人数',
        finishReviewerNums: '已评论人数',
        cochairJudge: '副主席评判',
        ifPass: '是否通过',
        CochairIfPass: '副主席是否通过',
        CochairIfBest: '副主席是否推荐最佳',
        CochairBestReason: '副主席推荐理由',
        Remark: '评论',
        CochairRemark: '副主席评论',
        Reviewers: '评论员',
        reviewerLeast: '评论员(至少 ',
        reviewerLeastLast: ' 个)',
        name: '姓名',
        email: '邮箱',
        ifActive: '是否激活',
        inviteStatus: '邀请状态',
        chooseReviewer: '选择评论员',
        download: '下载论文',
        downloadFinal: '最终下载',
        setId: 'ID',
        copyright: '版权',
        packDownload: '打包下载',
        paperType: '论文类型',
        paper: '论文',
        summary: '长摘要',
        uploadTip: '请上传PDF文件',
        uploadTipDoc: '请上传pdf、doc、docx格式文件',
        uploadTipZip: '请上传pdf、rar、zip格式文件',
        rule: {
            submitUserId: '请选择提交人',
            paperTitle: '请输入论文标题',
            keywords: '请输入关键字',
            paperAbstract: '请输入论文摘要',
            filePath: '请上传论文文件',
            ifStudent: '请选择是否为学生',
            language: '请选择语言',
            topicList: '请选择领域',
            paperType: '请选择论文类型',
            presentationType: '请选择出席类型',
            authorList: '请输入作者',
            author: {
                salutationId: '请选择作者称呼',
                name: '请输入作者名字',
                organization: '请输入作者所属组织',
                country: '请选择作者所属国家',
                email: '请输入作者邮箱'
            },
            paper: '请选择论文',
            user: '请选择用户',
            review: '请输入评论',
            session: '请选择议题',
            ifPass: '请选择是否通过',
            evaluateType: '请选择评估类型',
            recommendType: '请选择论文接受建议',
            ifBest: '请选择是否推荐最佳',
            bestReason: '请选择最好的理由'
        },
        confirm: {
            question: '确认创建论文集？',
            notice: '请输入版本',
            certain: '确认',
            cancel: '取消',
            codeValid: '请输入版本'
        },
        deleteTip: '确定要删除论文',
        count: '论文数量',
        ai: {
            uploadBotton: '点击上传',
            title: '投稿智能助手',
            // content: '推荐使用投稿智能助手预填写功能，让AI帮你预填表。',
            content: '推荐使用投稿智能助手预填写功能，让AI帮你预填表。',
            content2: '（请注意AI也会犯错，请务必检查自动生成的内容）',
            paperPdf: '论文 PDF',
            select: '选择',
            oneClick: '一键填写',
            cancel: '取消',
            time: '已解析 {sec} 秒，进行中',
            timeOut: '解析 {sec} 秒，已完成',
            selectFile: '选取文件',
            timeError: '解析失败，请重新上传',
            faildUpload: '文件上传失败，请重新上传',
            pleaseSelect: '请选择上传文件',
            noValidData: '未检测到有效数据，请检查后重新上传',
            fileAlready: '上传文件已存在，请移除后重新上传',
        }
    },
    email: {
        SendTimeStart: '发送时间开始',
        SendTimeEnd: '发送时间结束',
        id: '邮件ID',
        subject: '主题',
        paperIds: '论文ID',
        fromEmail: '发送人',
        toEmail: '收件人',
        template: '模板',
        status: '邮件状态',
        operation: '操作 ',
        content: '内容',
        success: '是否成功',
        emailStatus: '发送状态',
        createTime: '创建时间',
        sendTime: '发送时间',
        latestSendTime: '最新发送时间',
        paperStatus: '论文状态',
        receiver: '人员',
        ScreeningEmail:'按作者筛选',
        filterPaper:'按论文筛选',
        rule: {
            userIdList: '请选择邮件接收人',
            subject: '请输入邮件主题',
            cond1: '请选择',
            paperStatus: '请选择论文状态',
            receiver: '请选择人员',
            content: '请输入邮件内容'
        },
        deleteTip: '确定要删除邮件',
        Revieweremail: '评审员邮箱',
        invitationstatus: '邀请状态',
        Waiting: '等待接受',
        InvitationDate: '邀请时间',

        Accepted: '接受邀请',
        Rejected: '拒绝邀请',
        // Accepted: '已接受',
        // Rejected: '拒绝',
        Reviewed: '已评审',
        Back: '驳回意见',
        Sending: '发送中',
        Success: '发送成功',
        Fail: '发送失败',
        DeliverSuccess: '投递成功',
        DeliverFail: '投递失败',
        ResendMail: '重发邮件',
        Resend: '重发',
    },
    emailT: {
        id: '模板ID',
        title: '模板标题',
        operation: '操作',
        content: '内容',
        ifSystem: '是否是系统模板',
        normalT: '自定义模板',
        systemT: '系统模板',
        description: '描述',
        rule: {
            title: '请输入邮件模板标题',
            content: '请输入邮件模板内容',
            ifSystem: '请选择是否为系统模板'
        },
        deleteTip: '确定要删除邮件模板',
    },
    session: {
        id: '议题ID',
        title: '议题标题',
        type: '议题类型',
        place: '议题地点',
        operation: '操作',
        abstract: '议题摘要',
        rule: {
            title: '请输入议题标题',
            type: '请输入议题类型',
            place: '请输入议题地点'
        },
        deleteTip: '确定要删除议题'
    },
    topic: {
        id: '领域ID',
        title: '领域标题',
        en: '领域英文',
        operation: '操作',
        rule: {
            title: '请输入标题',
            en: '请输入英文版'
        },
        deleteTip: '确定要删除领域'
    },
    user: {
        id: '用户ID',
        loginName: '登录名',
        salutationName: '称呼',
        email: '邮箱',
        emailStandby: '备用邮箱',
        firstName: '姓',
        middleName: 'Middle Name',
        lastName: '名',
        suffix: '后缀',
        institution: '所属机构',
        department: '部门',
        address: '地址',
        addressStandby: '备用地址',
        country: '国家',
        province: '省',
        city: '城市',
        postalCode: '邮编',
        phone: '电话',
        fax: '传真',
        professionalField: '专业领域',
        operation: '操作',
        roles: '用户角色',
        role: '角色',
        deleteTip: '确定要删除用户'
    },
    cochair: {
        id: '副主席ID',
        userName: '用户名',
        realName: '真实姓名',
        password: '密码',
        passwordConfirm: '确认密码',
        email: '邮箱',
        operation: '操作',
        rule: {
            userName: '请输入用户名',
            realName: '请输入真实姓名',
            password: '请输入密码',
            passwordConfirm: '请输入确认密码',
            passwordNotEqual: '两次密码输入不一致',
            email: '请输入邮箱'
        },
        deleteTip: '确定要删除副主席'
    },
    invitationJudges: {
        title: '审稿人邀请',
        userName: '姓名',
        department: '单位',
        phone1: '手机',
        phone: '手机（新注册用户默认密码为手机号）',
        email: '邮箱',
        status: '审核状态',
        jobTitle: '职称',
        reviewerResearch: '研究方向',
        userNameMesage: '请输入姓名',
        departmentMesage: '请输入单位',
        phoneMesage: '手机号不能为空',
        emailMesage: '邮箱不能为空',
        jobTitleMesage: '请输入职称',
        topicMesage: '请输入领域',
        mobile2: '请输入正确的手机号',
        mobile3: '手机号已经注册，请点击底部链接，直接登录',
        email2: '请输入正确的邮箱',
        email3: '邮箱已经注册，请点击底部链接，直接登录',

        loginIn: "已注册用户，请登录！",

        reviewerResearchMesage: '请至少添加一个研究方向',
        submit1: '提交',
        reapply: '再次申请',
        add: '添加',

        message1: '您已经申请成功，等待审核！',
        message2: '您的申请已通过，请关注邮件，接受论文审核邀请。',
        message3: '您的申请已拒绝！',
        message4: '填报已经结束！',

        prompt: '提示',
        message: '此审核操作将不能修改, 是否继续?',
        submit: '确定',
        ok: '确定',
        cancel: '取消',
        Operation: '操作成功！',
        info: '取消操作！',
    }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js